import { MixerCotainer } from './Styled';

const Mixer = () => {
    return(
        <MixerCotainer>
            lol mixer
        </MixerCotainer>
    )
}

export default Mixer;